import Directory from "../views/Directory";

export default [
  {
    path: "/",
    name: "Directory",
    component: Directory,
    meta: {
      bgColor: "avo",
      fgColor: "brown"
    }
  },
  {
    path: "/about",
    name: "About",
    component: () => import(/* webpackChunkName: "about" */ "../views/About"),
    meta: {
      bgColor: "brown",
      fgColor: "egg"
    }
  },
  {
    path: "/stories/:slug",
    name: "Story",
    component: () => import(/* webpackChunkName: "story" */ "../views/Story"),
    meta: {
      bgColor: "egg",
      fgColor: "brown"
    }
  },
  {
    path: "/stories",
    name: "Stories",
    component: () =>
      import(/* webpackChunkName: "stories" */ "../views/Stories"),
    meta: {
      bgColor: "egg",
      fgColor: "brown"
    }
  },
  {
    path: "/terms",
    name: "Terms",
    component: () => import(/* webpackChunkName: "404" */ "../views/Terms"),
    meta: {
      bgColor: "brown",
      fgColor: "egg"
    }
  },
  {
    path: "/404",
    name: "404",
    component: () => import(/* webpackChunkName: "404" */ "../views/NotFound"),
    meta: {
      bgColor: "avo",
      fgColor: "brown"
    }
  },
  {
    path: "*",
    redirect: "/404"
  }
];
